import { render } from "./notasLateralComponent.vue?vue&type=template&id=ee1f3b06"
import script from "./notasLateralComponent.vue?vue&type=script&lang=js"
export * from "./notasLateralComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\VR-DEV001\\Documents\\repositorios\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__